export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/arts_crafts.b26a0c5.svg";